import { Typography } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import { mustAskApplicantSIN, mustAskCoapplicantSIN } from '../../credit-hooks'
import UpdateApplicantButton from '../UpdateApplicantButton'
import DeleteCoApplicantButton from '../DeleteCoapplicantButton'

interface Props {
  creditApp: CreditApplication
}

const PrequalNewToCredit = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const applicantNeedsSIN = mustAskApplicantSIN(creditApp)
  const coapplicantNeedsSIN = mustAskCoapplicantSIN(creditApp)

  return (
    <>
      {applicantNeedsSIN && (
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('viewCreditApplication.applicantNewToCreditWarning')}
        </Typography>
      )}
      {coapplicantNeedsSIN && (
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('viewCreditApplication.coapplicantNewToCreditWarning')}
        </Typography>
      )}
      <UpdateApplicantButton id={creditApp.id} financingProgramId={creditApp.financingProgramId} />
      {coapplicantNeedsSIN && (
        <DeleteCoApplicantButton id={creditApp.id} financingProgramId={creditApp.financingProgramId} />
      )}
    </>
  )
}

export default PrequalNewToCredit
